<template lang="pug">
.conteudo
    .linha(style='margin: 0px')
        .coluna
            title-component(:label='$route.meta.titulo')
    .linha(style='padding-top: 0px')
        .coluna
            dashboard-component
    .linha
        .coluna
            filtro-pagina-inicial-component(
                ref="filtroComponente",
                :municipios='municipiosFiltrados',
                :regionais='regionaisFiltradas',
                :mostrarFaseProcesso='mostrarFaseProcessoFiltro',
                :mostrarRegional='mostrarRegionalFiltro',
                @filtro:pesquisar='pesquisar($event, false)',
                @filtro:limpar='limpar',
                @regional:alterada='buscarMunicipiosDisponiveis'
                @municipio:alterado='buscarRegionaisDisponiveis'
            )

    .linha.listagem-linha
        .coluna-15
            b.coluna-4 Listagem de processos
        .coluna-11.botao-container


            el-button(@click="exportExcel" class="botao ativo")
                i(class="fas fa-list")  Exportar Relatório .xls
    .linha
        .coluna
            pagina-inicial-table-component(
                :headers='headersFiltrados',
                :data='paginacao.processos',
                :paginacao='paginacao',
                :is-loading='isLoading',
                :mostrarFaseProcesso='mostrarFaseProcessoFiltro',
                @inbox:page-change='checkPaginationChange($event)',
                @inbox:pagination='getPagination($event)'
            )
</template>

<script>
import {
    listar,
    listarPageConsultarProcessos,
    listarPageExportXls,
    listarPageReanalise,
    listarPageTermoCompromisso,
    listarPageValidacaoProposta,
    listarPaginaInicialGO,
} from '@/services/processo.service';
import {listarMunicipios, obterRegionais} from '@/services/regiao.service';
import FiltroPaginaInicialComponent from '@/components/standard/FiltroPaginaInicialComponent.vue';
import ButtonComponent from '@/components/standard/ButtonComponent.vue';
import DashboardComponent from '@/views/paginaInicial/components/DashBoard.vue';
import PaginaInicialTableComponent from '@/views/paginaInicial/components/PaginaInicialTable.vue';
import {Perfil} from '@/utils/constants.utils.js';
import EtapaEnum from '@/enums/EtapaEnum';
import * as XLSX from 'xlsx';

export default {
    name: 'PaginaInicialComponent',
    components: {
        ButtonComponent,
        FiltroPaginaInicialComponent,
        PaginaInicialTableComponent,
        DashboardComponent
    },
    data() {
        return {
            headers: [
                {
                    text: '',
                    field: 'processoSelecionado',
                    maxWidth: '',
                },
                {
                    text: 'CAR',
                    field: 'codigoImovel',
                    maxWidth: '',
                },
                {
                    text: '',
                    field: 'copiarCodigoImovel',
                    maxWidth: '',
                },
                {
                    text: 'Município',
                    field: 'municipio',
                    maxWidth: '',
                },
                {
                    text: 'Data da assinatura',
                    field: 'data_assinatura',
                    maxWidth: '',
                },
                {
                    text: 'Fase do processo',
                    field: 'condicaoInscricao',
                    maxWidth: ''
                },
                {
                    text: 'Vinculação',
                    field: 'dataVinculoTecnico',
                    maxWidth: ''
                },
                {
                    text: 'Condição',
                    field: 'condicao',
                    maxWidth: '',
                },
                {
                    text: 'Ações',
                    sortable: false,
                    field: 'acao',
                    maxWidth: '',
                },
            ],
            paginacao: {
                total: 0,
                pagina: 1,
                numeroPaginas: 0,
                quantidadePagina: 10,
                processos: [],
            },
            options: [10, 20, 50, 100, 1000],
            filtro: {},
            municipiosAll: [],
            regionaisAll: [],
            municipiosFiltrados: [],
            regionaisFiltradas: [],
            isLoading: false,
            mostrarFaseProcesso: false,
            filtroCarregado: false,
            listagemProcessosMap: {
                'Validação da Proposta': listarPageValidacaoProposta,
                'Página Inicial': listarPageExportXls,
                'Termo de Compromisso': listarPageTermoCompromisso,
                'Consultar processos': listarPageConsultarProcessos,
                'Em Reanálise': listarPageReanalise,
                'Análise da Proposta': listar,
            },
        };
    },

    async created() {
        this.isLoading = true;
        this.municipiosAll =  await listarMunicipios();
        this.regionaisAll = await obterRegionais();

        this.municipiosFiltrados = [...this.municipiosAll];
        this.regionaisFiltradas =  [...this.regionaisAll];

        this.isLoading = false;
        this.filtroCarregado = true;
    },
    computed: {
        mostrarFaseProcessoFiltro(){
            return this.$route.meta.mostrarFaseProcesso;
        },
        mostrarRegionalFiltro() {
            return this.$eu().perfil === Perfil.GERENTE_OPERACIONAL && this.$route.meta.titulo === EtapaEnum.PAGINA_INICIAL.nome;
        },
        headersFiltrados() {
            return this.headers.filter(header => {
                if (header.field === 'condicaoInscricao' || header.field === 'processoSelecionado') {
                    return this.mostrarFaseProcessoFiltro;
                }
                if (header.field === 'dataVinculoTecnico') {
                    return ! this.mostrarFaseProcessoFiltro;
                }
                return true; // Exibe o header "Vinculação" independentemente
            });
        }
    },

    methods: {
        async pesquisar(filtro) {
            this.filtro = filtro;
            this.isLoading = true;

            this.paginacao.processos = [];

            this.paginacao = await listarPaginaInicialGO(filtro);
            this.paginacao.processos = this.paginacao.processos.map(item => ({
                ...item,
                selecionado: false
            }));
            this.isLoading = false;

        },

        limpar() {

            this.municipiosFiltrados = [...this.municipiosAll];
            this.regionaisFiltradas = [...this.regionaisAll];

            const limpo = {
                total: 0,
                pagina: 1,
                numeroPaginas: 0,
                quantidadePagina: 10,
                processos: [],
            };
            this.pesquisar(limpo);
        },

        checkPaginationChange(page) {
            this.pesquisar({
                ...this.filtro,
                pagina: page,
            });
        },

        getPagination(paginationEvent) {
            return paginationEvent;
        },

        async exportExcel() {
            this.isLoading = true;

            const quantidadePaginaOriginal = this.filtro.quantidadePagina;
            const paginaOriginal = this.filtro.pagina;

            this.filtro.quantidadePagina= 100000;
            this.filtro.pagina = 1;

            try {
                const paginaAtual = this.$route.meta.titulo;
                const listarProcessos = this.listagemProcessosMap[paginaAtual];
                const dadosExportacao = await listarProcessos(this.filtro);

                const dadosFormat = dadosExportacao.processos.map(item => {
                    return {
                        'Código do Imóvel': item.codigoImovel,
                        'Termo de Compromisso': item.termo,
                        'Número do Prada': item.numero_prada,
                        'Município': item.municipio,
                        'Nome do Imóvel': item.nomeImovel,
                        'Compromissários': item.cpf_completo,
                        'Número de Módulos Fiscais': item.mod_fiscais,
                        'Data da Assinatura': item.data_assinatura,
                        'Tipo Assinatura': item.tipo_assinatura,
                        'Projeto': item.projeto,
                        'Área': item.area,
                        'Data Início': item.dat_inicio,
                        'Data Fim': item.dat_fim
                    };
                });

                const worksheet = XLSX.utils.json_to_sheet(dadosFormat);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "Planilha1");
                XLSX.writeFile(workbook, "arquivo.xlsx");

                this.filtro.quantidadePagina = quantidadePaginaOriginal;
                this.filtro.pagina = paginaOriginal;

                await this.pesquisar(this.filtro);
            } catch (error) {
                console.error('Erro ao exportar para Excel:', error);
            } finally {
                this.isLoading = false;
            }
        },
        async buscarMunicipiosDisponiveis(regional) {

            if (!regional) {
                this.municipiosFiltrados = [...this.municipiosAll];
                return;
            }

            this.municipiosFiltrados = await listarMunicipios(regional);
        },
        async buscarRegionaisDisponiveis(municipio) {

            if (!municipio) {
                this.regionaisFiltradas = [...this.regionaisAll];
                return;
            }

            this.regionaisFiltradas = await obterRegionais(municipio);
        }
    },
};
</script>

<style lang="scss" scoped>
.paginacao {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.listagem-linha {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 10px;
}

.botao-container {
  text-align: right;
    margin-right: 10px;
}
.ativo {
        background-color: #4caf50 !important;
        color: white !important;
    }

.dwitempg{
  margin-right: 20px
}
select {
  padding: 5px;
  font-size: 14px;
}
</style>
